import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';

// Models

import {
  Contributor,
  ContributorRole,
  MapArchiveEntry,
  MapEntryDetails,
  MapOrg,
  MapOrgRole,
  RecordType,
  PublicationType,
} from '@models';

@Injectable({
  providedIn: 'root',
})
export class MapArchiveService {
  private http = inject(HttpClient);

  contribRole = ContributorRole;
  mapOrgRole = MapOrgRole;
  recordType = RecordType;
  publicationType = PublicationType;

  mapDataset = environment.mapArchiveDatasetId;
  endpoint = `${environment.kinkoHost}/dataset/${this.mapDataset}/record/`;

  // Default form values set when creating a new map entry.

  defaultContributors = [
    {
      name: 'Oddveig Øien Ørvoll',
      email: 'oddveig.orvoll@npolar.no',
      roles: [this.contribRole['Archivist'], this.contribRole['Curator']],
    } as Contributor,
  ];

  defaultOrganisations = [
    {
      name: 'Norwegian Polar Institute',
      url: 'https://npolar.no/',
      roles: [this.mapOrgRole['Archive']],
      archiveInfo: {
        copies: 1,
        room: '5083',
      },
    } as MapOrg,
  ];

  addMap(title: string) {
    // Create map entry with title provided + NPI as an archive org

    return this.http.post<MapArchiveEntry>(
      this.endpoint,
      {
        type: this.recordType['map'],
        content: {
          title: title,
          entryType: this.publicationType['Single'],
          contributors: this.defaultContributors,
          organisations: this.defaultOrganisations,
        } as MapEntryDetails,
      } as MapArchiveEntry,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      },
    );
  }

  getMap(id: string) {
    return this.http.get<MapArchiveEntry>(this.endpoint + id, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  updateMap(id: string, entry: MapArchiveEntry) {
    if (!entry.content.mapType) {
      entry.content.mapType = undefined;
    }

    for (const org of entry.content.organisations) {
      if (!org.url) {
        org.url = undefined;
      }
      if (org.archiveInfo) {
        if (!org.archiveInfo.room) {
          org.archiveInfo.room = undefined;
        }
        if (!org.archiveInfo.storageRef) {
          org.archiveInfo.storageRef = undefined;
        }
      }
    }

    return this.http.put<MapEntryDetails>(this.endpoint + id, entry, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    });
  }

  removeMap(id: string) {
    return this.http.delete(this.endpoint + id, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }
}
